import { MultiWordTreeBuilder } from "../../General/Tree/MultiSet/multi-word-tree-builder";
import { MultiSetTreeNode } from "../../General/Tree/MultiSet/multi-set-tree-node";
import { Node } from "../../General/graph/lib/node";
import { SubTreeWords } from "./sub-tree-words";

export class TreeWords extends MultiWordTreeBuilder {
    subNode: MultiSetTreeNode;
    subGraph: SubTreeWords;
    subGraphMode: boolean = false;

    getSelectedNode(): Node {
        if (this.subGraphMode) {
            return this.subGraph.selectedNode;
        }
        return this.selectedNode;
    }

    resetSelectedNode() {
        if (this.selectedNode != null) {
            this.selectedNode.resetColor();
        }
        if (this.subGraphMode) {
            if (this.subGraph.selectedNode != null) {
                this.subGraph.selectedNode.resetColor();
                this.subGraph.selectedNode = null;
            }
        }
        this.selectedNode = null;
        this.update();
    }

    setHiddenNodes(content: any[][]) {
        content.forEach(c => {
            this.nodes.forEach(node => {
                if (node instanceof MultiSetTreeNode) {
                    if (this.equalContent(node.getContent(), c)) {
                        node.setHidden(true);
                    }
                }
            })
        })

        if (this.subGraph != null) {
            this.subGraph.setHiddenNodes(content);
        }
    }

    getHiddenNodes(): any[][] {
        let content: any[][] = [];
        this.nodes.forEach(node => {
            if (node instanceof MultiSetTreeNode) {
                if (node.isHidden()) {
                    content.push(node.getContent());
                }
            }
        })
        return content;
    }

    getHiddenNodesAsNodes(): Node[] {
        let hidden: Node[] = [];
        this.nodes.forEach(node => {
            if (node instanceof MultiSetTreeNode) {
                if (node.isHidden()) {
                    let alreadycontained: boolean = false;
                    hidden.forEach(h => {
                        if (h instanceof MultiSetTreeNode) {
                            if (this.equalContent(h.getContent(), node.getContent())) {
                                alreadycontained = true;
                            }
                        }
                    })
                    if (!alreadycontained) {
                        if (this.subGraphMode) {
                            if(this.subNode.getContent().length <= node.getContent().length ){
                                let isSubSet: boolean = true;
                                for(let i = 0; i < this.subNode.getContent().length; i++){
                                    if(node.getContent()[i] != this.subNode.getContent()[i]){
                                        isSubSet = false;
                                    }
                                }
                                if(isSubSet){
                                    hidden.push(node);
                                }
                            }
                        } else {
                            hidden.push(node);
                        }
                    }
                }
            }
        })
        return hidden;
    }

    setSubNode(subContent: any[]) {
        this.nodes.forEach(node => {
            if (node instanceof MultiSetTreeNode) {
                if (this.equalContent(subContent, node.getContent())) {
                    this.buildTree();
                    this.subNode = node;
                    this.subGraph = new SubTreeWords(this.subNode, this.canvas);
                    this.subGraph.buildTree();
                    this.subGraphMode = true;
                    this.update();
                    return;
                }
            }
        })
    }
    setSubGraphMode() {
        this.subGraphMode = true;
    }

    setGraphMode() {
        this.subGraphMode = false;
    }

    doubleClick() {
        return;
    }

    leftClick(row: number, col: number, node: Node, e: MouseEvent) {
        if (this.subGraphMode)
            return;

       // console.log("Subraphmode: " + this.subGraphMode);
        let clickedNode: MultiSetTreeNode = null;

        this.nodes.forEach(n => {
            if (n.inParameter(e, this.grid)) {
                if (n instanceof MultiSetTreeNode) {
                    clickedNode = n;
                }
            }
        })

        if (clickedNode == null)
            return;

        if (this.selectedNode != null) {
            this.selectedNode.resetColor();
        }

        if (this.selectedNode == clickedNode) {
            this.selectedNode == null;
            return;
        }

        this.selectedNode = clickedNode;
        clickedNode.selected();

      //  console.log("TREEWORDS Click at: " + clickedNode.getContent());



        this.update();
    }

    update() {
        if (this.subGraphMode) {
          //  console.log("Update from subgraphmode");
            this.subGraph.update();
        }
        else {
            super.update();
        }
    }

    buildTree() {
        super.buildTree();
    }

    keyboardEvent() {
        return;
    }
    rightClick() {
        return;
    }

    equalContent(content1: any[], content2: any[]): boolean {
        if (content1 == null || content2 == null) {
            return false;
        }
        if (content1.length != content2.length) {
            return false;
        }

        for (let i = 0; i < content1.length; i++) {
            if (!(content1[i] == content2[i])) {
                return false;
            }
        }
        return true;
    }
}
